import { notification } from 'antd';

// Код 15 сервер сопровождает осмысленным русским comment с именем объекта
// («Ответ с id=386 "A1" уже использован в анкетировании»), поэтому свой текст
// для него не задаём — comment информативнее.
export const OBJECT_IS_USED = '15';

const ERROR_TEXTS = {
  3: 'Ответы нельзя передавать вперемешку: либо все существующие, либо все новые',
  6: 'Такая связь создаст цикл в цепочке вопросов',
  24: 'Эта связь уже существует',
  78: 'Объект не найден — возможно, он уже удалён',
};

export const getError = (e) => e?.data?.error || e?.response?.data?.error || null;

export const isObjectUsed = (e) => String(getError(e)?.code) === OBJECT_IS_USED;

export const showServerError = (e, fallback) => {
  const error = getError(e);
  notification.error({
    message: error?.text?.rus || 'Ошибка',
    description: ERROR_TEXTS[String(error?.code)] || error?.comment || fallback,
    duration: 6,
  });
};
